export { isObject as isObject };
export { isToday as isToday };
export { getRandomBsVariant as getRandomBsVariant };
export { isDynamicRouteActive as isDynamicRouteActive };
export { useRouter as useRouter };
import router from '@/router';
import * as vue_composition_api from '@vue/composition-api';


const isObject = obj => typeof obj === 'object' && obj !== null;
const isToday = date => {
  const today = new Date();
  return /* eslint-disable operator-linebreak */(
    date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear()
    /* eslint-enable */
  );
};
const getRandomFromArray = array => array[Math.floor(Math.random() * array.length)];

// ? Light and Dark variant is not included
// prettier-ignore
const getRandomBsVariant = () => getRandomFromArray(['primary', 'secondary', 'success', 'warning', 'danger', 'info']);
const isDynamicRouteActive = route => {
  const {
    route: resolvedRoute
  } = router.resolve(route);
  return resolvedRoute.path === router.currentRoute.path;
};

// Thanks: https://medium.com/better-programming/reactive-vue-routes-with-the-composition-api-18c1abd878d1
const useRouter = () => {
  const vm = vue_composition_api.getCurrentInstance().proxy;
  const state = vue_composition_api.reactive({
    route: vm.$route
  });
  vue_composition_api.watch(() => vm.$route, r => {
    state.route = r;
  });
  return {
    ...vue_composition_api.toRefs(state),
    router: vm.$router
  };
};

/**
 * This is just enhancement over Object.extend [Gives deep extend]
 * @param {target} a Object which contains values to be overridden
 * @param {source} b Object which contains values to override
 */
// export const objectExtend = (a, b) => {
//   // Don't touch 'null' or 'undefined' objects.
//   if (a == null || b == null) {
//     return a
//   }

//   Object.keys(b).forEach(key => {
//     if (Object.prototype.toString.call(b[key]) === '[object Object]') {
//       if (Object.prototype.toString.call(a[key]) !== '[object Object]') {
//         // eslint-disable-next-line no-param-reassign
//         a[key] = b[key]
//       } else {
//         // eslint-disable-next-line no-param-reassign
//         a[key] = objectExtend(a[key], b[key])
//       }
//     } else {
//       // eslint-disable-next-line no-param-reassign
//       a[key] = b[key]
//     }
//   })

//   return a
// }

export default { isObject, isToday, getRandomBsVariant, isDynamicRouteActive, useRouter };
